/* eslint-disable no-unused-vars */
import { Label, Table, IconButton as IconButtonWithText } from '../../../../Components/uielements';
import {
  IconButton,
  ModalButtonWrapper,
  OutlineButton,
  TableCell,
  TableWrapper,
} from '../../../../services/settings/appStyle/global.style';
import { ModalGap, ModalWrapper } from '../premise.style';
import { IntlMessages } from '../../../../helper/langHelper';
import { useUserContext } from '../../../../hooks/UserContext';
import { useMemo, useState } from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import CompanyService from '../../../../services/bioplus-services/company';
import PremiseAlertReceiverService from '../../../../services/bioplus-services/premise-alert-receiver';
import { AddPlusIcon } from '../../../../Components/icons';
import ChildModal from '../../../../Components/uielements/modal/childModal';
import { getListOfAlertReceivers } from '../../../../services/bioplus-services/geofence';

const getCompanyManagers = async (userRole, companyId, page, pageSize, geofenceId) => {
  switch (userRole.role) {
    // case 'PARTNER': {
    //   return await CompanyService.partnerListCompanyUsers(
    //     userRole.companyId,
    //     companyId,
    //     ['OWNER', 'MANAGER', 'CORPORATE_ADMIN'],
    //     page,
    //     pageSize
    //   );
    // }
    case 'CORPORATE_ADMIN':
    case 'OWNER':
    case 'VISITOR':
    case 'MANAGER':
    case 'CONTRACTOR':
    case 'SUPPLIER':
    case 'EMPLOYEE':
    case 'ADMIN':
    case 'PARTNER':
      // return await CompanyService.listCompanyUsers(
      //   companyId,
      //   ['OWNER', 'MANAGER', 'CORPORATE_ADMIN'],
      //   page,
      //   pageSize
      // );
      // return await CompanyService.listUserRoles(companyId, page, pageSize);
      return await getListOfAlertReceivers({ geofenceId, companyId });

    default:
      return [];
  }
};
const addAlertReceiver = async (userRole, geofenceId, userId) => {
  switch (userRole.role) {
    // case 'PARTNER':
    //   return await PremiseAlertReceiverService.partnerAdd(userRole.companyId, geofenceId, userId);
    case 'CORPORATE_ADMIN':
    case 'OWNER':
    case 'VISITOR':
    case 'MANAGER':
    case 'CONTRACTOR':
    case 'SUPPLIER':
    case 'EMPLOYEE':
    case 'ADMIN':
    case 'PARTNER':
      return await PremiseAlertReceiverService.addToGeofence(geofenceId, userId);
    default:
      return false;
  }
};

const AddAlertReceiverToPremiseModal = ({
  onClose,
  geofence,
  isManager,
  companyId,
  invalidateQuery,
}) => {
  const userContext = useUserContext();
  const userRole = userContext.company;
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [addingUserId, setAddingUserId] = useState(undefined);

  const query = useQuery(['companyManagers', userRole], () =>
    getCompanyManagers(userRole, companyId, page, pageSize, geofence._id)
  );
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (args) => addAlertReceiver(args.userRole, args.geofenceId, args.userId),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['alert-receivers'] });
      isManager
        ? await queryClient.invalidateQueries({ queryKey: ['managerPremises'] })
        : queryClient.invalidateQueries({ queryKey: [invalidateQuery] });
    },
    onError: (e) => {
      if (e?.response?.status === 400) {
        alert(e?.response?.data?.message);
      } else {
        alert(e.message);
      }
    },
  });

  const onSelected = async (user) => {
    setAddingUserId(user?._id);
    try {
      await mutation.mutateAsync({ userRole, geofenceId: geofence?._id, userId: user?._id });
      onClose && onClose();
    } catch (e) {
      // onError above already surfaces the message; just clear loading state.
    } finally {
      setAddingUserId(undefined);
    }
  };

  const userData = query?.data ?? [];

  const alertReceiversColumns = useMemo(
    () => [
      {
        Header: <IntlMessages id="table.col.receiver.name" />,
        accessor: 'userName',
        Cell: (cellData) => (
          <TableCell>{`${cellData?.row?.original?.firstName} ${cellData?.row?.original?.lastName}`}</TableCell>
        ),
      },
      {
        Header: <IntlMessages id="table.col.email" />,
        accessor: 'email',
      },
      {
        Header: <IntlMessages id="table.col.actions" />,
        accessor: 'role',
        id: 'actions',
        isAction: true,
      },
    ],
    []
  );

  const actionList = [
    (data) => {
      const isThisRowLoading = mutation.isLoading && addingUserId === data?._id;
      return (
        <IconButton onClick={() => onSelected(data)}>
          <IconButtonWithText
            disabled={mutation.isLoading}
            text={
              isThisRowLoading ? (
                <IntlMessages id="loading.adding" />
              ) : (
                <IntlMessages id="button.text.add" />
              )
            }
            icon={<AddPlusIcon />}
          />
        </IconButton>
      );
    },
  ];

  const handleNextPage = () => {
    setPage((value) => value + 1);
  };
  const handlePreviousPage = () => {
    setPage((value) => value - 1);
  };

  return (
    <>
      <ChildModal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="modal.text.alert.receiver" />}
      >
        {query.isLoading ? (
          <ModalWrapper>
            <Label>
              <IntlMessages id="loading.text" />
            </Label>
          </ModalWrapper>
        ) : query.isError ? (
          <ModalWrapper>
            <Label>
              <IntlMessages id="error.message" />
            </Label>{' '}
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose}>
                <IntlMessages id="modal.button.cancel" />
              </OutlineButton>
            </ModalButtonWrapper>
          </ModalWrapper>
        ) : (
          <ModalWrapper>
            <ModalGap>
              <TableWrapper>
                <Table
                  data={userData}
                  columns={alertReceiversColumns}
                  hasFooter={true}
                  page={page}
                  pageSize={pageSize}
                  prevPage={handlePreviousPage}
                  nextPage={handleNextPage}
                  total={userData?.length || 0}
                  actions={actionList}
                  isActionsRenderConditinal={true}
                />
              </TableWrapper>
            </ModalGap>
            <ModalButtonWrapper>
              <OutlineButton onClick={onClose} disabled={mutation.isLoading}>
                <IntlMessages id="modal.button.cancel" />
              </OutlineButton>
            </ModalButtonWrapper>
          </ModalWrapper>
        )}
      </ChildModal>
    </>
  );
};

export default AddAlertReceiverToPremiseModal;
